<template>
  <div>
    <div class="text-center" v-if="loading">
      <b-spinner class="ms-2" variant="primary"></b-spinner>
    </div>
    <div v-if="tabela && !loading">
      <div>
        <b-table
          responsive="sm"
          :items="dadosEnderecos"
          :fields="camposEndereco"
          per-page="1000"
          striped
        >
          <template #cell(options)="data">
            <div class="d-flex justify-content-end">
              <b-button
                size="sm"
                class="me-1"
                variant="primary"
                @click="editarEndereco(data.item)"
                data-tooltip="Editar"
                data-tooltip-location="left"
              >
                <i class="mdi mdi-pencil"></i>
              </b-button>
              <b-button
                size="sm"
                class="me-1"
                variant="danger"
                @click="excluirEndereco(data.item)"
                data-tooltip="Excluir"
                data-tooltip-location="left"
              >
                <i class="mdi mdi-trash-can"></i>
              </b-button>
            </div>
          </template>
        </b-table>
      </div>
      <div>
        <div class="mt-1 d-flex justify-content-end">
          <b-button variant="info" class="mt-5 mb-3" @click="incluir()">
            <i class="mdi mdi-plus"></i>
            Incluir
          </b-button>
        </div>
      </div>
      <div class="row">
        <div class="mt-1 d-flex justify-content-between">
          <b-button
            class="mt-1 me-1"
            @click="navegar('idiomas', false)"
            data-tooltip="Voltar"
            data-tooltip-location="bottom"
          >
            <i class="mdi mdi-arrow-left-circle font-size-15"></i>
          </b-button>
          <b-button
            variant="primary"
            class="mt-1"
            @click="navegar('contatos', true)"
            data-tooltip="Próximo"
            data-tooltip-location="bottom"
          >
            <i class="mdi mdi-arrow-right-circle font-size-15"></i>
          </b-button>
        </div>
      </div>
    </div>
    <div v-if="!tabela && !loading">
      <div class="row">
        <div class="col-md-2">
          <b-form-group
            class="mb-3"
            label="CEP"
            invalid-feedback="Digite um CEP válido"
          >
            <b-form-input
              v-model="dados.cep"
              type="text"
              v-mask="'#####-###'"
              maxlength="9"
              autocomplete="off"
              @blur="consultaCep()"
              :state="validacaoCep"
            ></b-form-input>
          </b-form-group>
        </div>
        <div class="col-md-5" v-if="this.mostraMunicipio">
          <b-form-group class="mb-3" label="Município - UF">
            <b-form-input
              v-model="dados.municipioUf"
              readonly
              type="text"
            ></b-form-input>
          </b-form-group>
        </div>
        <div class="col-md-5" v-if="this.mostraMunicipio">
          <b-form-group class="mb-3" label="Bairro">
            <b-form-input
              v-model="dados.dsBairro"
              :disabled="!cepSimples"
              type="text"
            ></b-form-input>
          </b-form-group>
        </div>
      </div>
      <div class="row">
        <div class="col-md-4" v-if="this.mostraMunicipio">
          <b-form-group class="mb-3" label="Logradouro">
            <multiselect
              v-model="selectTipLog"
              placeholder="Selecione"
              :show-labels="false"
              label="ds_tipo_logradouro"
              :options="optionsTipLog"
              :disabled="!cepSimples"
            />
          </b-form-group>
        </div>
        <div class="col-md-6" v-if="this.mostraMunicipio">
          <b-form-group class="mb-3" label="Endereço">
            <b-form-input
              v-model="dados.dsEndereco"
              :disabled="!cepSimples"
              type="text"
            ></b-form-input>
          </b-form-group>
        </div>
        <div class="col-md-2" v-if="this.mostraMunicipio">
          <b-form-group class="mb-3" label="N°">
            <b-form-input
              v-model="dados.nrEndereco"
              autocomplete="off"
              trim
              maxlength="5"
              type="text"
            ></b-form-input>
          </b-form-group>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12" v-if="this.mostraMunicipio">
          <b-form-group class="mb-3" label="Complemento">
            <b-form-input
              v-model="dados.dsComplemento"
              type="text"
              trim
              maxlength="50"
            ></b-form-input>
            <div class="text-center">
              <p
                v-if="dados.dsComplemento"
                class="badge position-absolute"
                :class="{
                  'bg-success': dados.dsComplemento.length !== 50,
                  'bg-danger': dados.dsComplemento.length === 50,
                }"
              >
                {{ dados.dsComplemento.length }} / 50
              </p>
            </div>
          </b-form-group>
        </div>
      </div>
      <div class="row">
        <div class="col-md-4">
          <div>
            <b-form-checkbox
              id="checkbox-1"
              v-model="dados.principal"
              :unchecked-value="false"
              :value="true"
              :disabled="disabledPrincipal == true"
              plain
            >
              Endereço Principal
            </b-form-checkbox>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="mt-1 d-flex justify-content-between">
          <b-button
            class="mt-1 me-1"
            @click="tabela = true"
            data-tooltip="Voltar"
            data-tooltip-location="bottom"
          >
            <i class="mdi mdi-arrow-left-circle font-size-15"></i>
          </b-button>
          <b-button
            class="mt-1 me-1"
            variant="success"
            @click="salvar()"
            :disabled="disabledSalvar"
            data-tooltip="Salvar"
            data-tooltip-location="bottom"
          >
            <i class="mdi mdi-content-save"></i>
            <b-spinner
              variant="primary"
              small
              class="ms-2"
              v-if="loadingSalvar"
            ></b-spinner>
          </b-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Multiselect from "vue-multiselect";
const capitalizeString = (str) => {
  return str
    .split(" ")
    .map((word) => {
      return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
    })
    .join(" ");
};
export default {
  components: {
    Multiselect,
  },
  data() {
    return {
      dados: {
        sqEndereco: "",
        dsEndereco: "",
        cep: "",
        municipioUf: "",
        dsBairro: "",
        cdTipoLogradouro: "",
        cdTipo: "2",
        sqRegiao: "",
        nrEndereco: "",
        dsComplemento: "",
        principal: "",
      },
      selectTipLog: {},
      disabledPrincipal: "",
      camposEndereco: [
        {
          key: "NRCEP",
          label: "CEP",
        },
        {
          key: "NMREGIAO",
          label: "Cidade",
          formatter: (value) => {
            if (!value || typeof value !== "string") return value || "";
            const partes = value.split(" - ");
            if (partes.length < 2) return capitalizeString(value);
            const parte1 = capitalizeString(partes[0]);
            const parte2 = partes[1].toUpperCase();
            return parte1 + " - " + parte2;
          },
        },
        {
          key: "DSTIPOLOGRADOURO",
          label: "Logradouro",
          formatter: (value) => {
            return capitalizeString(value);
          },
        },
        {
          key: "DSENDERECO",
          label: "Endereço",
          formatter: (value) => {
            return capitalizeString(value);
          },
        },
        {
          key: "NRENDERECO",
          label: "N°",
        },
        {
          key: "PRINCIPAL",
          label: "Principal",
        },
        {
          key: "options",
          label: "",
        },
      ],
      optionsTipLog: [],
      dadosEnderecos: [],
      cidades: [],
      cdIbge: "",
      loading: true,
      tabela: true,
      mostraMunicipio: false,
      validacaoCep: null,
      avancar: null,
      cepSimples: false,
      loadingSalvar: false,
      disabledSalvar: false,
    };
  },

  created() {
    this.buscarTipLog();
    this.buscarEndereco();
  },

  methods: {
    buscarEndereco() {
      this.$http
        .get("api/profileErp/enderecos")
        .then((response) => {
          this.dadosEnderecos = (response.data || []).map((item) => {
            let nmRegiao = "";
            if (item.Cidade && typeof item.Cidade === "object") {
              const nomeCidade = item.Cidade.Nome || item.Cidade.nome || "";
              const estadoCidade = item.Cidade.Estado || item.Cidade.estado || "";
              nmRegiao = nomeCidade && estadoCidade ? `${nomeCidade} - ${estadoCidade}` : nomeCidade;
            } else if (typeof item.Cidade === "string") {
              nmRegiao = item.Cidade;
            } else {
              nmRegiao = item.NMREGIAO || item.nmRegiao || item.cidade || item.municipioUf || item.municipio || "";
            }

            let dsTipoLogradouro = "";
            const idTipoLog = item.TipoLogradouro?.Id || item.TipoLogradouro?.id || item.IdTipoLogradouro || item.idTipoLogradouro;
            if (item.TipoLogradouro && typeof item.TipoLogradouro === "object") {
              dsTipoLogradouro = item.TipoLogradouro.Descricao || item.TipoLogradouro.descricao || "";
            } else if (typeof item.TipoLogradouro === "string") {
              dsTipoLogradouro = item.TipoLogradouro;
            } else {
              dsTipoLogradouro = item.DSTIPOLOGRADOURO || item.dsTipoLogradouro || item.tipoLogradouro || "";
            }

            if (!dsTipoLogradouro && idTipoLog) {
              const foundTip = (this.optionsTipLog || []).find(el => el.cd_tipo_logradouro == idTipoLog || el.id == idTipoLog || el.Id == idTipoLog);
              if (foundTip) {
                dsTipoLogradouro = foundTip.ds_tipo_logradouro || foundTip.nm_tipo_logradouro || foundTip.Descricao || "";
              }
            }

            const isPrincipal = item.Principal === true || item.principal === true || item.stPrincipal === "S" || item.st_principal === "S" || item.PRINCIPAL === "Sim" || item.Principal === "S";

            return {
              ...item,
              NRCEP: item.NRCEP || item.nrCep || item.cep || item.Cep || "",
              NMREGIAO: nmRegiao,
              DSBAIRRO: item.DSBAIRRO || item.dsBairro || item.bairro || item.Bairro || "",
              DSCOMPLEMENTO: item.DSCOMPLEMENTO || item.dsComplemento || item.complemento || item.Complemento || "",
              DSTIPOLOGRADOURO: dsTipoLogradouro,
              DSENDERECO: item.DSENDERECO || item.dsEndereco || item.Endereco || item.endereco || item.logradouro || item.Logradouro || "",
              NRENDERECO: item.NRENDERECO || item.nrEndereco || item.Numero || item.numero || "",
              PRINCIPAL: isPrincipal ? "Sim" : "Não",
              Principal: isPrincipal,
              principal: isPrincipal,
              SQENDERECO: item.SQENDERECO || item.sqEndereco || item.Id || item.id || "",
              SQREGIAO: item.Cidade?.Id || item.Cidade?.id || item.SQREGIAO || item.sqRegiao || item.idCidade || item.IdRegiaoCidade || "",
              CDIBGE: item.Cidade?.CodigoIbge || item.Cidade?.codigoIbge || item.cdIbge || item.CdIbge || ""
            };
          });
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },

    buscarTipLog() {
      this.$http.get("api/cadastroCandidato/buscarTipLog").then((response) => {
        this.optionsTipLog = (response.data || []).map(item => ({
          ...item,
          id: item.cd_tipo_logradouro || item.id || item.Id,
          Descricao: item.ds_tipo_logradouro || item.Descricao || item.descricao
        }));
        if (this.dadosEnderecos && this.dadosEnderecos.length > 0) {
          this.buscarEndereco();
        }
      });
    },

    navegar(nomeAba, direcao) {
      this.$emit("navegar", nomeAba, direcao);
    },

    consultaCep() {
      var cep = this.dados.cep;
      if (!cep) return;
      cep = cep.replace("-", "").replace(".", "").trim();
      this.dados.dsEndereco = "";
      this.dados.dsBairro = "";

      if (cep.length >= 8) {
        this.$http
          .get("api/profileErp/enderecos/consultar-por-cep", { params: { Cep: cep } })
          .then((response) => {
            const data = response.data || {};
            if (data.Message || data.erro) {
              this.validacaoCep = false;
              this.mostraMunicipio = false;
              return;
            }
            this.validacaoCep = null;
            this.sqRegiao = data.RegiaoId || null;
            const aux = data.DadosApi || data;
            this.cdIbge = aux.ibge || "";
            
            if (aux.localidade && aux.uf) {
              var montaNome = capitalizeString(aux.localidade) + " - " + aux.uf;
              this.dados.municipioUf = montaNome.toString();
            }
            if (aux.bairro) {
              this.dados.dsBairro = aux.bairro;
            }
            if (aux.logradouro) {
              this.cepSimples = false;
              this.separarLogradouroDeEndereco(aux.logradouro);
            } else {
              this.cepSimples = true;
            }
            this.mostraMunicipio = true;
          })
          .catch(() => {
            this.validacaoCep = false;
            this.mostraMunicipio = false;
          });
      }
    },

    separarLogradouroDeEndereco(item) {
      const tipoLogradouro = item.split(" ")[0];
      const dsEndereco = item.split(" ").slice(1).join(" ");
      this.dados.dsEndereco = dsEndereco;
      this.selectTipLog = this.optionsTipLog.find(
        (el) =>
          el.ds_tipo_logradouro.toLowerCase() === tipoLogradouro.toLowerCase()
      );
    },

    salvar() {
      var cep = this.dados.cep.replace("-", "");
      this.loadingSalvar = true;
      this.disabledSalvar = true;
      if (
        !this.dados.dsEndereco ||
        !this.dados.dsBairro ||
        !this.dados.nrEndereco ||
        !this.dados.cep
      ) {
        this.$tools.alerta(
          "Por favor, para continuar preencha todos os campos",
          "warning"
        );
        this.loadingSalvar = false;
        this.disabledSalvar = false;
        return;
      }

        const isPrincipalBool = Boolean(this.dados.principal);

        const payload = {
          Cep: cep,
          cep: cep,
          NrCep: cep,
          nrCep: cep,
          
          Logradouro: this.dados.dsEndereco,
          logradouro: this.dados.dsEndereco,
          DsEndereco: this.dados.dsEndereco,
          dsEndereco: this.dados.dsEndereco,
          
          Numero: this.dados.nrEndereco,
          numero: this.dados.nrEndereco,
          NrEndereco: this.dados.nrEndereco,
          nrEndereco: this.dados.nrEndereco,
          
          Bairro: this.dados.dsBairro,
          bairro: this.dados.dsBairro,
          DsBairro: this.dados.dsBairro,
          dsBairro: this.dados.dsBairro,
          
          Complemento: this.dados.dsComplemento,
          complemento: this.dados.dsComplemento,
          DsComplemento: this.dados.dsComplemento,
          dsComplemento: this.dados.dsComplemento,
          
          Principal: isPrincipalBool ? "S" : "N",
          principal: isPrincipalBool ? "S" : "N",
          StPrincipal: isPrincipalBool ? "S" : "N",
          stPrincipal: isPrincipalBool ? "S" : "N",
          
          IdTipoLogradouro: this.selectTipLog?.cd_tipo_logradouro || this.selectTipLog?.id || 1,
          idTipoLogradouro: this.selectTipLog?.cd_tipo_logradouro || this.selectTipLog?.id || 1,
          CdTipoLogradouro: this.selectTipLog?.cd_tipo_logradouro || this.selectTipLog?.id || 1,
          cdTipoLogradouro: this.selectTipLog?.cd_tipo_logradouro || this.selectTipLog?.id || 1,
          
          CdIbge: this.cdIbge,
          cdIbge: this.cdIbge,
          IdCidade: this.sqRegiao || this.cdIbge,
          idCidade: this.sqRegiao || this.cdIbge,
          
          // Novos campos mapeados para o portal_api (novo ERP)
          IdTipoContatoEndereco: 1, // Default Residencial
          IdRegiaoCidade: this.sqRegiao || this.cdIbge,
          Endereco: this.dados.dsEndereco,
          Referencia: this.dados.dsPontoReferencia || this.dados.Referencia || "",
        };

        const isEdit = !!this.dados.sqEndereco;
        const url = isEdit ? `api/profileErp/enderecos/${this.dados.sqEndereco}` : "api/profileErp/enderecos";
        const requestAction = isEdit ? this.$http.put(url, payload) : this.$http.post(url, payload);

        requestAction
          .then(() => {
            this.$tools.alerta("Salvo com sucesso", "success");
            this.loadingSalvar = false;
            this.disabledSalvar = false;
            this.$emit("carregarNivelPerfil");
            this.buscarEndereco();
            this.tabela = !this.tabela;
          })
          .catch((err) => {
            this.loadingSalvar = false;
            this.disabledSalvar = false;
            this.$tools.alerta(err.response?.data?.message || "Não foi possível cadastrar o endereço no ERP", "error");
          });
      },

      incluir() {
        (this.dados.sqEndereco = ""),
          (this.dados.dsEndereco = ""),
          (this.dados.cep = ""),
          (this.dados.municipioUf = ""),
          (this.dados.dsBairro = ""),
          (this.dados.nrEndereco = ""),
          (this.dados.dsComplemento = ""),
          (this.dados.sqRegiao = "");
        (this.selectTipLog = {}), (this.tabela = false);
        this.mostraMunicipio = false;
        if (this.dadosEnderecos.length == 0) {
          this.dados.principal = true;
          this.disabledPrincipal = true;
        } else {
          this.dados.principal = false;
          this.disabledPrincipal = "";
        }
      },

      editarEndereco(item) {
        this.dados.cep = item.NRCEP;
        this.dados.municipioUf = item.NMREGIAO;
        this.dados.dsBairro = item.DSBAIRRO;
        this.dados.nrEndereco = item.NRENDERECO;
        this.dados.dsComplemento = item.DSCOMPLEMENTO;
        this.dados.dsEndereco = item.DSENDERECO;
        const idTipoLog = item.TipoLogradouro?.Id || item.TipoLogradouro?.id || item.IdTipoLogradouro || item.idTipoLogradouro;
        this.selectTipLog = this.optionsTipLog.find(
          (el) =>
            (idTipoLog && (el.cd_tipo_logradouro == idTipoLog || el.id == idTipoLog)) ||
            (item.DSTIPOLOGRADOURO && el.ds_tipo_logradouro?.toLowerCase() === item.DSTIPOLOGRADOURO?.toLowerCase())
        ) || { cd_tipo_logradouro: idTipoLog || 1 };
        const isPrincipal = item.PRINCIPAL === "Sim" || item.Principal === true || item.principal === true || item.stPrincipal === "S" || item.Principal === "S";
        this.dados.principal = isPrincipal;
        this.disabledPrincipal = isPrincipal ? true : "";
        this.dados.sqEndereco = item.SQENDERECO;
        this.dados.sqRegiao = item.SQREGIAO;
        this.sqRegiao = item.SQREGIAO;
        this.cdIbge = item.CDIBGE || item.cdIbge || "";
        this.tabela = false;
        this.mostraMunicipio = true;
      },

    excluirEndereco(item) {
      if (item.PRINCIPAL === "Sim") {
        this.$tools.alerta(
          "Não é possível excluir um endereço principal",
          "warning"
        );
      } else {
        this.$http
          .delete("api/profileErp/enderecos/" + item.SQENDERECO)
          .then(() => {
            this.$tools.alerta("Excluído com sucesso", "success");
            this.buscarEndereco();
          })
          .catch((err) => {
            this.$tools.alerta(err.response?.data?.message || "Erro ao excluir o endereço no ERP", "error");
          });
      }
    },
  },
};
</script>
